/*
 * Copyright (c) 2026, Gather
 * https://gather.life
 */

import Divider from '@mui/material/Divider/Divider';
import IconButton from '@mui/material/IconButton/IconButton';
import InputAdornment from '@mui/material/InputAdornment/InputAdornment';
import { type SyntheticEvent, type ReactNode } from 'react';

import { Icon } from '@marketplace/gather-ui/components/icon';
import { AppSpacing } from '@marketplace/gather-ui/theme/constants';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';

const inputAdornmentStyles = { gap: AppSpacing.XS, pr: AppSpacing.SM };
const dividerStyles = { alignSelf: 'center', height: AppSpacing.LG, mx: AppSpacing.XXS };

type EndAdornmentProps = {
  inputContainsValue: boolean;
  onReset: (inputEvent: SyntheticEvent) => void;
  onSubmit: (inputEvent: SyntheticEvent) => void;
};

export function EndAdornment({
  inputContainsValue,
  onReset,
  onSubmit,
}: EndAdornmentProps): ReactNode {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <InputAdornment position='end' sx={inputAdornmentStyles}>
        {inputContainsValue ? (
          <IconButton
            aria-label='Clear search'
            color='transparent'
            edge='end'
            size='x-small'
            onClick={onReset}
          >
            <Icon color='primary' icon='close' />
          </IconButton>
        ) : null}
      </InputAdornment>
    );
  }

  return (
    <InputAdornment position='end' sx={inputAdornmentStyles}>
      <>
        {inputContainsValue ? (
          <>
            <IconButton
              aria-label='Clear search'
              color='transparent'
              edge='end'
              size='x-small'
              onClick={onReset}
            >
              <Icon color='primary' icon='close' />
            </IconButton>
            <Divider flexItem orientation='vertical' sx={dividerStyles} />
          </>
        ) : null}
        <IconButton
          aria-label='Submit search'
          color='transparent'
          edge='end'
          size='small'
          onClick={onSubmit}
        >
          <Icon color='primary' icon='searchLarge' />
        </IconButton>
      </>
    </InputAdornment>
  );
}
